import React from 'react'
import { Stack } from '@mui/material'
import {categories} from '../utils/constants'
// const selectedCategory='Coding'

const SideBar = ({selectedCategory,setSelectedCategory}) =>  (
  <Stack direction="row" sx={{overflow:'auto' ,height:{sx:'auto',md:'100%'}, flexDirection:{md:'column'}}}>
{categories.map((category)=>(
<button className='category-btn' 
onClick={()=>setSelectedCategory(category.name)}
style={{background:category.name=== selectedCategory && '#FC1503',color:'white'}} >
    <span   style={{color:category.name=== selectedCategory ? 'white' : 'red' , paddingRight:'14px'}} >{category.icon}</span>
    <span style={{opacity:category.name=== selectedCategory ? '1' :'0.6' }} >{category.name}</span>
</button>
))}
  </Stack>
  )


export default SideBar